import { Pill } from "@mantine/core"
import { FieldFilterValue } from "../../orval/gen/model"
import { getFormattedDatePeriod } from "../../utils/get-formatted-date"
import { getDateOnly } from "../date-only"

export function FieldFilterPill({
  filter,
  typeName,
  onRemove,
}: {
  filter: FieldFilterValue
  typeName: string
  onRemove: () => void
}) {
  let displayStr = ""
  switch (filter.dataType) {
    case "Date":
      const start = filter.values?.[0] ?? null
      const end = filter.values?.[1] ?? null
      displayStr = getFormattedDatePeriod({
        start: start ? getDateOnly(start) : null,
        end: end ? getDateOnly(end) : null,
      })
      break
    case "Bool":
      break
    default:
      displayStr = filter.values?.filter((v) => !!v).join(", ") ?? ""
  }

  return (
    <Pill size="lg" withRemoveButton removeButtonProps={{ onClick: onRemove }}>
      {typeName}
      {displayStr ? ": " + displayStr : ""}
    </Pill>
  )
}
